/**
 * Reload / logout / auth headers must send the hex session id. The backend stores a JSON pool
 * in mother_session_id / father_session_id; hydrated child rows may stringify that blob into
 * userstate/localStorage unless we normalize.
 */
export function normalizeSessionHex(raw) {
    if (raw == null || raw === '') return '';
    const s = String(raw).trim();
    if (!s.startsWith('[')) return s;
    try {
        const parsed = JSON.parse(s);
        if (Array.isArray(parsed) && parsed.length > 0) {
            const last = parsed[parsed.length - 1];
            return last?.id != null ? String(last.id).trim() : '';
        }
    } catch {
        /* ignore */
    }
    return '';
}
